import React, { useState } from 'react';
import { Button, Card, CardBody, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import './AIAssistantSettings.css';
import { widgetSelectStyles } from '../../../components/AIAssistant/widgetSettingsStyles';
import LiveChatSettingsPanel from '../../../components/AIAssistant/LiveChatSettingsPanel';

const AIAssistantSettings = () => {
    const [selectedPlacement, setSelectedPlacement] = useState('product_below_content');
    const [removeModal, setRemoveModal] = useState(false);

    const placementOptions = [
        { value: 'product_below_content', label: 'Below Product Content' },
        { value: 'product_above_content', label: 'Above Product Content' },
        { value: 'product_sidebar', label: 'Product Sidebar' },
        { value: 'product_tabs', label: 'Product Tabs' },
        { value: 'product_gallery', label: 'Product Gallery' },
        { value: 'cart_page', label: 'Cart Page' },
        { value: 'checkout_page', label: 'Checkout Page' }
    ];

    const handlePlacementChange = (selectedOption) => {
        setSelectedPlacement(selectedOption.value);
    };

    const handleInsertWidget = () => {
        // TODO: Implement widget insertion logic
        console.log('Inserting widget at:', selectedPlacement);
        alert(`Widget will be inserted at: ${selectedPlacement}`);
    };

    const handleRemoveWidget = () => {
        setRemoveModal(true);
    };

    const confirmRemoveWidget = () => {
        // TODO: Implement widget removal logic
        console.log('Removing widget');
        alert('Widget has been removed from your store');
        setRemoveModal(false);
    };

    return (
        <React.Fragment>
            <div className="widget-management-page">
                    <h2 className="mb-2">Widget Management</h2>
                    <p className="page-intro">
                        Manage your ConversionBox AI Shopping Assistant widget placement and configuration.
                    </p>

                            {/* Widget Placement Section */}
                            <Card className="settings-card">
                                <CardBody className="settings-card-body">
                                    <h6>Widget Placement</h6>
                                    
                                    <div className="placement-container">
                                        <div className="select-container">
                                            <Label className="widget-region-label">Region</Label>
                                            <Select
                                                value={placementOptions.find(option => option.value === selectedPlacement)}
                                                onChange={handlePlacementChange}
                                                options={placementOptions}
                                                styles={widgetSelectStyles}
                                                isSearchable={false}
                                                placeholder="Select placement..."
                                            />
                                        </div>
                                        <Button
                                            color="primary"
                                            className="conversionBox"
                                            onClick={handleInsertWidget}
                                            style={{ 
                                                height: '40px',
                                                padding: '8px 20px',
                                                fontSize: '0.9rem'
                                            }}
                                        >
                                            Insert Widget
                                        </Button>
                                    </div>
                                    
                                    <p className="placement-description">
                                        Select a region where you want to place the ConversionBox AI Shopping Assistant widget.
                                    </p>
                                </CardBody>
                            </Card>

                            {/* Widget Removal Section */}
                            <Card className="settings-card">
                                <CardBody className="settings-card-body">
                                    <h6>Widget Removal</h6>
                                    
                                    <Button
                                        color="danger"
                                        className="remove-button"
                                        onClick={handleRemoveWidget}
                                    >
                                        Remove Widget
                                    </Button>
                                    
                                    <div className="warning-message warning-message--banner">
                                        <FontAwesomeIcon 
                                            icon={faExclamationTriangle} 
                                            className="warning-icon"
                                        />
                                        <span>
                                            This will permanently remove the widget from your store. You can always insert it again later.
                                        </span>
                                    </div>
                                </CardBody>
                            </Card>

                            <LiveChatSettingsPanel selectStyles={widgetSelectStyles} />

                {/* Remove Widget Confirmation Modal */}
                {removeModal && (
                    <div 
                        className="modal-backdrop" 
                        onClick={() => setRemoveModal(false)}
                    >
                        <div 
                            className="modal-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <h5 className="modal-title">
                                Confirm Widget Removal
                            </h5>
                            <p className="modal-description">
                                Are you sure you want to remove the ConversionBox AI Shopping Assistant widget from your store? This action cannot be undone.
                            </p>
                            <div className="modal-buttons">
                                <Button
                                    color="secondary"
                                    className="modal-button modal-button-secondary"
                                    onClick={() => setRemoveModal(false)}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    color="danger"
                                    className="modal-button modal-button-danger"
                                    onClick={confirmRemoveWidget}
                                >
                                    Remove Widget
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}

export default AIAssistantSettings;
